module.exports = __webpack_public_path__ + "static/media/up-logo.a30293fe.svg";